import { collection, query, where, doc, getDocs, updateDoc, onSnapshot, setDoc, orderBy, Timestamp, getDoc, getCountFromServer } from "firebase/firestore";
import { db } from '@/firebase/firebaseInit';

import { getDateInYYMMDD } from '@/utils';
import { getDateFromFDID } from '@/utils';

var unsubscribeDeliveries;

function calculateAge(activeBeneficiary) {
    var dob = activeBeneficiary.date_of_birth;
    var yob = activeBeneficiary.year_of_birth;
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var age = -1;
    if (dob != "") {
        var d = new Date(dob);
        var birthYear = d.getFullYear();
        age = currentYear - birthYear;
        return age;
    } else if (yob != "") {
        age = currentYear - yob;
        return age;
    }
    return age;
}

async function lookupConsecutiveUndeliveredCount(beneficiary, fdID) {
    var beneficiaryID = String(beneficiary.id);
    var counter;
    var keepLooking = true;
    var currentFDDate = getDateFromFDID(String(fdID));

    for(counter = 0; counter < 5 && keepLooking; ) {

        var previousFDDate = new Date(currentFDDate.getTime() - 7 * 24 * 60 * 60 * 1000);

        // if last_activation_date exists, compare with it, otherwise fallback to date_of_approval
        if (beneficiary.last_activation_date ? previousFDDate > beneficiary.last_activation_date.toDate() : previousFDDate > new Date(beneficiary.date_of_approval)) {

            var previousFDID = getDateInYYMMDD(previousFDDate);

            // find the delivery for this beneficiary for the week of previousFDID
            const docSnap = await getDoc(doc(db, "fds/" + previousFDID + "/deliveries/", beneficiaryID));

            if(docSnap.exists()) {
                // delivery found! check the status
                if (docSnap.data().status == 'DELIVERED' || docSnap.data().status == 'SELF_PICKUP') {
                    console.log("Successful Delivery found for beneficiaryID: " + beneficiaryID + " for FD: " + previousFDID);
                    keepLooking = false;
                } else {
                    // unsuccessful delivery, keep looking
                    counter++;
                    currentFDDate = previousFDDate;
                }
            } else {
                // delivery not found. beneficiary was not created/activated. Stop looking
                keepLooking = false;
            }
        } else {
            // beneficary wasn't activated. stop looking.
            keepLooking = false;
        }
    }
    return counter;
}

async function splitDeliveriesToTeams(querySnapshot, fdID, totalTeams, teamType) {
    const totalDeliveries = querySnapshot.size;
    var remainingDeliveries = totalDeliveries;
    var remainingTeams = totalTeams;
    var deliveriesPerTeam = Math.ceil(totalDeliveries / remainingTeams);
    console.log(teamType + " deliveries: " + totalDeliveries + " and teams: " + remainingTeams);
    var i = 1;
    var walkingDeliverySort = 1;
    var teamNumber = 1;
    querySnapshot.forEach((doc) => {
        var deliverySort = 0;
        if (teamType == 'walking') {
            deliverySort = walkingDeliverySort;
            walkingDeliverySort++;
        } else if (teamType == 'driving') {
            deliverySort = doc.data().delivery_sort;
        }
        if (i <= deliveriesPerTeam) {
            // console.log(teamType + teamNumber + " - delivery" + i + " : " + doc.data().block + " " + doc.data().unit + " - " + deliverySort);
            updateDeliveryTeam(fdID, doc.data().beneficiary_id, teamType + teamNumber, deliverySort);
            i++;
        } else {
            remainingDeliveries = remainingDeliveries - deliveriesPerTeam;
            remainingTeams--;
            teamNumber++;
            deliveriesPerTeam = Math.ceil(remainingDeliveries / remainingTeams);
            i = 1;
            // console.log(teamType + teamNumber + " - delivery" + i + " : " + doc.data().block + " " + doc.data().unit + " - " + deliverySort);
            updateDeliveryTeam(fdID, doc.data().beneficiary_id, teamType + teamNumber, deliverySort);
            i++;
        }
    });
}

async function updateDeliveryTeam(fdID, deliveryID, deliveryTeam, deliverySort) {
    // console.log("Delivery: " + fdID + "/" + deliveryID + " to team: '" + deliveryTeam + "' delivery_sort: " + deliverySort);
    const docRef = doc(db, "fds/" + fdID + "/deliveries", String(deliveryID));
    try {
        await updateDoc(docRef, {
            delivery_team: deliveryTeam,
            delivery_sort: deliverySort
        });
    } catch (error) {
        console.log(error);
    }
}

export default {

    async getAllDeliveries(context, payload) {
        const q = query(collection(db, "fds/" + payload + "/deliveries"));
        try {
            unsubscribeDeliveries = onSnapshot(q, (querySnapshot) => {
                const deliveries = [];
                querySnapshot.forEach((doc) => {
                    deliveries.push(doc.data());
                });
                context.commit("setAllDeliveries", deliveries);
                console.log("Deliveries found: " + querySnapshot.size)
            });
        } catch (error) {
            console.log(error);
        }
    },

    async getDeliveriesForTeam(context, payload) {
        if (!payload.fdTeam) {
            throw new Error("You are not assigned to a delivery team. Please contact an Apex member.");
        }

        if (unsubscribeDeliveries) unsubscribeDeliveries();

        try {
            const q = query(collection(db, "fds/" + payload.fdID + "/deliveries"), where("delivery_team", "==", payload.fdTeam));
            unsubscribeDeliveries = onSnapshot(q, (querySnapshot) => {
                const deliveries = [];
                var normalBags = 0;
                var dryBags = 0;
                var completedDeliveries = 0;
                var remainingDeliveries = 0;
                querySnapshot.forEach((doc) => {
                    const delivery = doc.data();
                    if (delivery.dry_bag) {
                        dryBags = dryBags + delivery.quantity;
                    } else {
                        normalBags = normalBags + delivery.quantity;
                    }
                    if (delivery.completed) {
                        completedDeliveries = completedDeliveries + delivery.quantity;
                    } else {
                        remainingDeliveries = remainingDeliveries + delivery.quantity;
                    }
                    deliveries.push(delivery)
                })
                context.commit("setDeliveries", deliveries);
                context.commit("setDeliveryBagsCount", {
                    normalBags,
                    dryBags,
                    completedDeliveries,
                    remainingDeliveries
                })
                console.log("Normal: " + normalBags + " Dry: " + dryBags);
            });
        } catch (error) {
            throw new Error(error.message);
        }
    },

    unsubDeliveries() {
        if (unsubscribeDeliveries) {
            unsubscribeDeliveries();
            console.log("Unsubscribing Deliveries")
        }
    },

    async loadPendingSelfCollection(context, payload) {
        console.log("Attempting to load Pending Self Collection for FD ID: " + payload)
        const q = query(collection(db, "fds/" + String(payload) + "/deliveries"), where("completed", "==", false), where("self_collection", "==", true));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.size) {
            console.log(querySnapshot.size + " Pending Self Collections found!")
        }
        const deliveries = [];
        querySnapshot.forEach((doc) => {
            deliveries.push(doc.data());
        });
        context.commit("setPendingSelfCollection", deliveries);
    },

    async loadDeliveriesWithNotes(context, payload) {
        console.log("Attempting to load NOT Delivered for FD ID: " + payload)
        const q = query(collection(db, "fds/" + String(payload) + "/deliveries"), where("notes", "!=", ""));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.size) {
            console.log(querySnapshot.size + " NOT Delivered deliveries found!")
        }
        const deliveries = [];
        querySnapshot.forEach((doc) => {
            deliveries.push(doc.data());
        });
        context.commit("setNotDeliveredDeliveries", deliveries);
    },

    async generateDeliveries(context, payload) {
        const q = query(collection(db, "beneficiaries"), where("active", "==", true));

        const querySnapshot = await getDocs(q);
        const activeBeneficiaries = [];

        var countSelfCollection = 0;
        var countDriving = 0;
        var countWalking = 0;
        var dryBagsForDriving = 0;
        var normalBagsForDriving = 0;
        var dryBagsForSelfCollection = 0;
        var normalBagsForSelfCollection = 0;
        var dryBagsForWalking = 0;
        var normalBagsForWalking = 0;

        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots

            const beneficiary = doc.data();
            activeBeneficiaries.push(beneficiary)
        });
        context;
        console.log("Number of ACTIVE Beneficiaries found: " + activeBeneficiaries.length);
        context.commit("setTotalDeliveriesToGenerate", activeBeneficiaries.length);

        var deliveriesGeneratedCount = 0;

        for (var activeBeneficiary of activeBeneficiaries) {
            const consecutiveUndeliveredCount = await lookupConsecutiveUndeliveredCount(activeBeneficiary, payload.fdID);
            setDoc(doc(db, "fds/" + payload.fdID + "/deliveries", String(activeBeneficiary.id)), {
                beneficiary_id: activeBeneficiary.id,
                completed: false,
                full_name: activeBeneficiary.full_name,
                dry_bag: activeBeneficiary.dry_bag,
                driving_delivery: activeBeneficiary.driving_delivery,
                self_collection: activeBeneficiary.self_collection,
                age: calculateAge(activeBeneficiary),
                quantity: activeBeneficiary.quantity,
                block: String(activeBeneficiary.block),
                street: activeBeneficiary.street,
                unit: activeBeneficiary.unit,
                delivery_sort: activeBeneficiary.delivery_sort,
                bag_status: activeBeneficiary.bag_status,
                dietary_requirement: activeBeneficiary.dietary_requirement,
                consecutive_undelivered_count: consecutiveUndeliveredCount,
                location: activeBeneficiary.location || 'REDHILL',
                delivery_notes: activeBeneficiary.delivery_notes || ''
            });
            if (activeBeneficiary.self_collection) {
                countSelfCollection++;
                if (activeBeneficiary.dry_bag) {
                    dryBagsForSelfCollection = dryBagsForSelfCollection + activeBeneficiary.quantity;
                } else {
                    normalBagsForSelfCollection = normalBagsForSelfCollection + activeBeneficiary.quantity;
                }
            }
            else {
                if (activeBeneficiary.driving_delivery) {
                    countDriving++;
                    if (activeBeneficiary.dry_bag) {
                        dryBagsForDriving = dryBagsForDriving + activeBeneficiary.quantity;
                    } else {
                        normalBagsForDriving = normalBagsForDriving + activeBeneficiary.quantity;
                    }
                } else {
                    countWalking++;
                    if (activeBeneficiary.dry_bag) {
                        dryBagsForWalking = dryBagsForWalking + activeBeneficiary.quantity;
                    } else {
                        normalBagsForWalking = normalBagsForWalking + activeBeneficiary.quantity;
                    }
                }
            }
            deliveriesGeneratedCount++;
            context.commit("setDeliveriesGeneratedCount", deliveriesGeneratedCount);
        }

        const fdRef = doc(db, "fds", String(payload.fdID));

        await updateDoc(fdRef, {
            deliveries_generated: true,
            total: activeBeneficiaries.length,
            total_self_collection: countSelfCollection,
            total_driving_deliveries: countDriving,
            total_walking_deliveries: countWalking,
            self_collected: 0,
            walking_delivered: 0,
            driving_delivered: 0,
            total_dry_bags_to_pack: dryBagsForDriving + dryBagsForWalking,
            total_normal_bags_to_pack: normalBagsForDriving + normalBagsForWalking,
            total_dry_bags: dryBagsForDriving + dryBagsForWalking + dryBagsForSelfCollection,
            total_normal_bags: normalBagsForDriving + normalBagsForWalking + normalBagsForSelfCollection
        });
    },

    async assignDeliveriesToTeams(context, payload) {
        // Walking Deliveries sorted by Block and Unit
        const walkingDeliveries = query(collection(db, "fds/" + payload.fdID + "/deliveries"), where("self_collection", "==", false), where("driving_delivery", "==", false), orderBy("block"), orderBy("unit"));
        const walkingQuerySnapshot = await getDocs(walkingDeliveries);
        splitDeliveriesToTeams(walkingQuerySnapshot, payload.fdID, payload.countWalkingTeams, "walking");

        // Driving Deliveries sorted by Delivery Sort
        const drivingDeliveries = query(collection(db, "fds/" + payload.fdID + "/deliveries"), where("self_collection", "==", false), where("driving_delivery", "==", true), orderBy("delivery_sort"));
        const drivingQuerySnapshot = await getDocs(drivingDeliveries);
        splitDeliveriesToTeams(drivingQuerySnapshot, payload.fdID, payload.countDrivingTeams, "driving");

        // Marking deliveries assignment DONE for the FD
        const fdRef = doc(db, "fds", String(payload.fdID));
        try {
            await updateDoc(fdRef, {
                deliveries_assigned_to_teams: true
            });
        } catch (error) {
            console.log(error);
        }
    },

    async updateDeliveryModeAndTeam(context, payload) {
        const docRef = doc(db, "fds/" + payload.fdID + "/deliveries", String(payload.deliveryID));
        try {
            await updateDoc(docRef, {
                delivery_team: payload.deliveryTeam,
                self_collection: payload.selfCollection,
                driving_delivery: payload.drivingDelivery
            });
        } catch (error) {
            console.log(error);
        }
    },

    async searchDelivery(context, payload) {
        console.log("Searching delivery with fdID: " + payload.fdID + " and beneficiaryID: " + payload.beneficiaryID);
        const docSnap = await getDoc(doc(db, "fds/" + payload.fdID + "/deliveries/", String(payload.beneficiaryID)));

        if (docSnap.exists()) {
            context.commit("setDelivery", docSnap.data());
        } else {
            throw new Error("No Active Beneficiary found with ID '" + payload.beneficiaryID + "' for this Food Distribution.");
        }
    },

    async searchHistoricalDeliveries({ getters, commit }, payload) {
        var deliveries = []
        if (getters.getSearchHistoricalDeliveries) {
            deliveries = getters.getSearchHistoricalDeliveries;
        }
        var notDelivered;
        for (const fdID of payload.fdIDs) {
            const docSnap = await getDoc(doc(db, "fds/" + fdID + "/deliveries/", String(payload.beneficiaryID)));
            const delivery = docSnap.data()
            if (docSnap.exists()) {
                delivery.fd_id = fdID;
                deliveries.push(delivery);
                console.log("Delivery found for FD: " + fdID + " , " + delivery);
            } else {
                console.log("Delivery NOT found for FD: " + fdID);
                notDelivered = {
                    fd_id: fdID,
                    status: 'NOT_FOUND'
                }
                deliveries.push(notDelivered);
            }
        }
        commit("setSearchHistoricalDeliveries", deliveries);
    },

    resetHistoricalDeliveries(context) {
        context.commit("setSearchHistoricalDeliveries", null);
        console.log("Reset History");
    },

    async updateDelivery(context, payload) {
        console.log("Updating delivery with fdID: " + payload.fdID + " and beneficiaryID: " + payload.beneficiaryID);
        const deliveryRef = doc(db, "fds/" + payload.fdID + "/deliveries", String(payload.beneficiaryID));

        try {
            await updateDoc(deliveryRef, {
                notes: payload.notes,
                status: payload.status,
                completed: true,
                completed_at_time: Timestamp.fromDate(new Date())
            });
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch!');
        }
    },

    async fetchDeliveryStats(context, { fdID }) {
        context.commit('setDeliveryStatsLoading', true);
        const ref = collection(db, 'fds', String(fdID), 'deliveries');

        const countQ = (filters) => getCountFromServer(query(ref, ...filters));

        const lRH = [where('location', '==', 'REDHILL')];
        const lTBR = [where('location', '==', 'TBR')];

        const [
            rhTotal, rhSelfTotal, rhSelfDone,
            rhDrivingTotal, rhDrivingDelivered, rhDrivingNotDelivered,
            rhTotalDelivered, rhTotalNotDelivered, rhTotalPending,
            tbrTotal, tbrDone,
        ] = await Promise.all([
            countQ([...lRH]),
            countQ([...lRH, where('self_collection', '==', true)]),
            countQ([...lRH, where('self_collection', '==', true), where('completed', '==', true)]),
            countQ([...lRH, where('driving_delivery', '==', true)]),
            countQ([...lRH, where('driving_delivery', '==', true), where('status', '==', 'DELIVERED')]),
            countQ([...lRH, where('driving_delivery', '==', true), where('status', '==', 'NOT_DELIVERED')]),
            countQ([...lRH, where('status', '==', 'DELIVERED')]),
            countQ([...lRH, where('status', '==', 'NOT_DELIVERED')]),
            countQ([...lRH, where('completed', '==', false)]),
            countQ([...lTBR]),
            countQ([...lTBR, where('completed', '==', true)]),
        ].map(p => p.then(s => s.data().count)));

        const rhSelfPending = rhSelfTotal - rhSelfDone;
        const rhDrivingPending = rhDrivingTotal - rhDrivingDelivered - rhDrivingNotDelivered;
        const rhWalkingTotal = rhTotal - rhSelfTotal - rhDrivingTotal;
        const rhWalkingDelivered = rhTotalDelivered - rhDrivingDelivered;
        const rhWalkingNotDelivered = rhTotalNotDelivered - rhDrivingNotDelivered;
        const rhWalkingPending = rhTotalPending - rhSelfPending - rhDrivingPending;

        context.commit('setStatsRefreshCooldownUntil', Date.now() + 60 * 1000);
        context.commit('setDeliveryStats', {
            selfRedhill:  { total: rhSelfTotal,    done: rhSelfDone,              pending: rhSelfPending },
            selfTbr:      { total: tbrTotal,        done: tbrDone,                 pending: tbrTotal - tbrDone },
            walking:      { total: rhWalkingTotal,  delivered: rhWalkingDelivered, notDelivered: rhWalkingNotDelivered, pending: rhWalkingPending },
            driving:      { total: rhDrivingTotal,  delivered: rhDrivingDelivered, notDelivered: rhDrivingNotDelivered, pending: rhDrivingPending },
            grandTotal:   { total: rhTotal + tbrTotal, delivered: rhTotalDelivered, notDelivered: rhTotalNotDelivered, pending: rhTotalPending + (tbrTotal - tbrDone) },
        });
        context.commit('setDeliveryStatsLoading', false);
    },

    async updateDeliveryNotes(context, { fdID, beneficiaryID, deliveryNotes }) {
        const docRef = doc(db, "fds/" + fdID + "/deliveries", String(beneficiaryID));
        await updateDoc(docRef, {
            delivery_notes: deliveryNotes
        });
    }
};



